import type { ProjectMessages } from '../types';

const messages: ProjectMessages = {
  'projectDetail.label.lookDetailButton': '去查看',
} as const;

export default messages;
